import { render, staticRenderFns } from "./NotariesRequests.vue?vue&type=template&id=08c4d7fa&"
import script from "./NotariesRequests.vue?vue&type=script&lang=ts&"
export * from "./NotariesRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports